"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
var React = require("react");
var context_1 = require("./context");
var ThemeProvider = /** @class */ (function (_super) {
    __extends(ThemeProvider, _super);
    function ThemeProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.update = function (newState) {
            _this.setState(function (state) { return ({
                state: __assign(__assign({}, state.state), newState)
            }); });
        };
        _this.getContext = function () {
            return _this.state;
        };
        _this.state = {
            state: __assign({}, _this.props.value),
            update: _this.update
        };
        return _this;
    }
    ThemeProvider.prototype.render = function () {
        return (React.createElement(context_1.ThemeContext.Provider, { value: this.state }, this.props.children));
    };
    return ThemeProvider;
}(React.Component));
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=provider.js.map